<template>
  <div>
    <h3>Sync Planday Users</h3>

    <!-- <vs-button
        @click="syncUsers"
        id="sync-users-button"
        class="mt-4"
      >Sync Users</vs-button> -->

    <h5 v-if="message !== null">{{ message }}</h5>

    <vs-table
      v-if="message === null"
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="syncedUsers"
      @selected="onUserClicked(selected)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                syncedUsers.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : syncedUsers.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Name</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="ssn">SSN</vs-th>
        <vs-th sort-key="didSync">Synced</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.firstName }} {{ tr.lastName }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.ssn }}</p>
            </vs-td>
            <vs-td>
              <vs-icon
                v-if="tr.didSync || tr.alreadySynced"
                icon="check"
                size="small"
                color="white"
                bg="lightgreen"
                round
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      syncedUsers: [],

      message: null,

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.syncedUsers.length;
    },
  },
  methods: {
    syncUsers: function () {
      this.$vs.loading();

      this.$http
        .post(process.env.VUE_APP_API + "/users/planday")
        .then(resp => {
          if (resp.data.hasMessage) {
            this.message = resp.data.message;
          }

          this.syncedUsers = resp.data.users;

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Planday Users synced",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not sync Planday Users:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onUserClicked(/*user*/) {
      //ROUTE TO USER
      this.$router.push({ name: "user" }).catch(() => {});
    },
  },
  created() {},
  mounted() {
    this.isMounted = true;
  },
};
</script>